<div class='mt-5 mb-1 text-center'>
    <div class='thexa-logo text-center d-inline-block mx-auto'>

        <img 
            src='/images/THEXA-On-Demand.png' 
            class='img-fluid mx-auto' 
            alt='THEXA'
        />

    </div>        
</div>

<style>
     .thexa-logo {
        max-width: 60%;
        height: auto;
    }
</style>